import I18n from 'components/I18n'
import CheckIcon from 'components/Icons/CheckIcon'
import palette from 'components/palette'
import messages from 'lang'
import transparentize from 'polished/lib/color/transparentize'
import React from 'react'
import ReactMarkdown from 'react-markdown'
import styled from 'styled-components'
import { color } from 'utils'

type FinishedStepProps = {
  onEdit: () => void
  title: string
}

const Wrapper = styled.div`
  border-top: 1px solid ${color('light')};
  display: grid;
  grid-template-columns: min-content 1fr auto;
  justify-content: flex-start;
  align-items: center;
  gap: 1rem;
  padding: 1rem 1.5rem;
`

const SectionTitle = styled.p`
  margin: 0;
`

const Button = styled.button`
  align-self: end;
  border-radius: 8px;
  background: ${transparentize('0.76', palette.blue400)};
  color: ${color('blue400')};
  padding: 4px 8px;
  border: none;
  font-weight: bold;
  cursor: pointer;
`

const FinishedStep = ({ onEdit, title }: FinishedStepProps) => {
  return (
    <Wrapper>
      <CheckIcon color={palette.green400} />
      <SectionTitle>
        <ReactMarkdown>{title}</ReactMarkdown>
      </SectionTitle>
      <Button onClick={onEdit}>
        <I18n data={messages.button_edit} />
      </Button>
    </Wrapper>
  )
}

export default FinishedStep
